import React, { useEffect, useState } from "react";
import { createLookupApi } from "../api/lookupApi";
import { listClassConfigurations } from "../api/classConfigurationApi";
import { listStudents } from "../api/studentApi";
import "../pages/Attendance/Attendance.css";

const academicYearApi = createLookupApi("academic-years");

/**
 * Shared academic-year → class → student picker, reused by every Phase 8
 * screen that acts on one student (fee collection, adjustments, payslip
 * generation) — the same three-step narrowing digicampusbd's own fee pages
 * did, just as one reusable component instead of copy-pasted per page.
 * Fires `onSelect(studentResponseOrNull)` whenever the resolved student
 * changes; `student.identificationId` is what every finance endpoint wants.
 */
export default function StudentPicker({ onSelect }) {
  const [academicYears, setAcademicYears] = useState([]);
  const [classConfigs, setClassConfigs] = useState([]);
  const [academicYear, setAcademicYear] = useState("");
  const [classConfigurationId, setClassConfigurationId] = useState("");
  const [students, setStudents] = useState([]);
  const [identificationId, setIdentificationId] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    Promise.all([academicYearApi.list(), listClassConfigurations()]).then(([years, configs]) => {
      setAcademicYears(years);
      setClassConfigs(configs);
      if (years.length > 0) setAcademicYear(years[0].name);
    });
  }, []);

  useEffect(() => {
    if (!academicYear) return;
    setLoading(true);
    listStudents(academicYear, classConfigurationId || undefined)
      .then((list) => {
        setStudents(list);
        setIdentificationId("");
      })
      .finally(() => setLoading(false));
  }, [academicYear, classConfigurationId]);

  useEffect(() => {
    const student = students.find((s) => String(s.identificationId) === identificationId) || null;
    onSelect(student);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [identificationId, students]);

  return (
    <div className="attendance-filters">
      <label>
        Academic Year
        <select value={academicYear} onChange={(e) => setAcademicYear(e.target.value)}>
          {academicYears.map((y) => (
            <option key={y.id} value={y.name}>
              {y.name}
            </option>
          ))}
        </select>
      </label>
      <label>
        Class
        <select value={classConfigurationId} onChange={(e) => setClassConfigurationId(e.target.value)}>
          <option value="">All classes</option>
          {classConfigs.map((c) => (
            <option key={c.id} value={c.id}>
              {c.classConfigName}
            </option>
          ))}
        </select>
      </label>
      <label>
        Student
        <select value={identificationId} onChange={(e) => setIdentificationId(e.target.value)} disabled={loading}>
          <option value="">{loading ? "Loading..." : "Select a student"}</option>
          {students.map((s) => (
            <option key={s.identificationId} value={s.identificationId}>
              {s.studentRoll ? `${s.studentRoll} - ` : ""}
              {s.studentName} ({s.customStudentId})
            </option>
          ))}
        </select>
      </label>
    </div>
  );
}
